"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductTypeByProductTabEnum = exports.ProductTabEnum = exports.ProductListActionTypes = exports.DefaultTabCodes = void 0;
var _product = require("@nucleo/product");
function cov_svnwfby5p() {
  var path = "/codebuild/output/src1340795087/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/nucleo/productList/lib/constants.js";
  var hash = "0cb4b172da2682e6cd0f0173deb3a7f48829ced0";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src1340795087/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/nucleo/productList/lib/constants.js",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 38
        },
        end: {
          line: 13,
          column: 1
        }
      },
      "1": {
        start: {
          line: 15,
          column: 30
        },
        end: {
          line: 25,
          column: 1
        }
      },
      "2": {
        start: {
          line: 27,
          column: 43
        },
        end: {
          line: 75,
          column: 1
        }
      },
      "3": {
        start: {
          line: 77,
          column: 31
        },
        end: {
          line: 86,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "0cb4b172da2682e6cd0f0173deb3a7f48829ced0"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_svnwfby5p = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_svnwfby5p();
var ProductListActionTypes = exports.ProductListActionTypes = (cov_svnwfby5p().s[0]++, {
  PRODUCT_LIST_BEFORE_LOAD: 'PRODUCT_LIST_BEFORE_LOAD',
  PRODUCT_LIST_BEFORE_LOAD_SUMMARY: 'PRODUCT_LIST_BEFORE_LOAD_SUMMARY',
  PRODUCT_LIST_LOAD_SUMMARY_SUCCESS: 'PRODUCT_LIST_LOAD_SUMMARY_SUCCESS',
  PRODUCT_LIST_CHANGE_TAB: 'PRODUCT_LIST_CHANGE_TAB',
  PRODUCT_LIST_BEFORE_LOAD_PRODUCTS: 'PRODUCT_LIST_BEFORE_LOAD_PRODUCTS',
  PRODUCT_LIST_LOAD_PRODUCTS_SUCCESS: 'PRODUCT_LIST_LOAD_PRODUCTS_SUCCESS',
  PRODUCT_LIST_LOAD_ERROR: 'PRODUCT_LIST_LOAD_ERROR',
  PRODUCT_LIST_CHANGE_FILTER_SUCCESS: 'PRODUCT_LIST_CHANGE_FILTER_SUCCESS',
  PRODUCT_LIST_SELECT_PRODUCT: 'PRODUCT_LIST_SELECT_PRODUCT'
});
var ProductTabEnum = exports.ProductTabEnum = (cov_svnwfby5p().s[1]++, {
  OFFERS: 'OFFERS',
  EVENTS: 'EVENTS',
  VISIT: 'VISIT',
  GOODS: 'GOODS',
  SEASON_TICKETS: 'SEASON_TICKETS',
  OTHER_PRODUCTS: 'OTHER_PRODUCTS',
  HOSPITALITY: 'HOSPITALITY',
  HOSPITALITY_BUNDLE: 'HOSPITALITY_BUNDLE',
  TOURS: 'TOURS'
});
var ProductTypeByProductTabEnum = exports.ProductTypeByProductTabEnum = (cov_svnwfby5p().s[2]++, {
  OFFERS: [_product.ProductTypeEnum.HOSPITALITY, _product.ProductTypeEnum.MEMBERSHIP, _product.ProductTypeEnum.PACKAGE, _product.ProductTypeEnum.PARKING, _product.ProductTypeEnum.SERVICE, _product.ProductTypeEnum.VOUCHER, _product.ProductTypeEnum.TIMESLOT_PASS, _product.ProductTypeEnum.EVENT, _product.ProductTypeEnum.SPORTING_EVENT, _product.ProductTypeEnum.VISIT, _product.ProductTypeEnum.VISIT_PASS, _product.ProductTypeEnum.GOODS, _product.ProductTypeEnum.SEASON_TICKET, _product.ProductTypeEnum.DONATION],
  EVENTS: [_product.ProductTypeEnum.EVENT, _product.ProductTypeEnum.SPORTING_EVENT],
  VISIT: [_product.ProductTypeEnum.VISIT, _product.ProductTypeEnum.VISIT_PASS],
  GOODS: [_product.ProductTypeEnum.GOODS],
  SEASON_TICKETS: [_product.ProductTypeEnum.SEASON_TICKET],
  OTHER_PRODUCTS: [_product.ProductTypeEnum.HOSPITALITY, _product.ProductTypeEnum.MEMBERSHIP, _product.ProductTypeEnum.PACKAGE, _product.ProductTypeEnum.PARKING, _product.ProductTypeEnum.SERVICE, _product.ProductTypeEnum.VOUCHER, _product.ProductTypeEnum.PASS, _product.ProductTypeEnum.TIMESLOT_PASS, _product.ProductTypeEnum.DONATION],
  HOSPITALITY: [ProductTabEnum.HOSPITALITY],
  HOSPITALITY_BUNDLE: [_product.ProductTypeEnum.HOSPITALITY_BUNDLE]
});
var DefaultTabCodes = exports.DefaultTabCodes = (cov_svnwfby5p().s[3]++, [ProductTabEnum.OFFERS, ProductTabEnum.EVENTS, ProductTabEnum.VISIT, ProductTabEnum.SEASON_TICKETS, ProductTabEnum.GOODS, ProductTabEnum.OTHER_PRODUCTS, ProductTabEnum.HOSPITALITY, ProductTabEnum.HOSPITALITY_BUNDLE]);